<template>

    <DashboardContainer :style="'px-0 mx-0'">

        <div class="mt-4">

            <DashboardCard
                    header-title="WhatsApp Config"
                    :refreshButton="true"
                     @refresh="loadInstitutions"
            >

                <div class="row">

                    <div class="col-md-6 mb-4">

                        <FormLabel
                                label-text="Institution ID"
                                :required="true"
                        />

                        <Select
        v-model="configData.institutionId"
        :options="institutions"
        optionLabel="displayName"
        optionValue="id"
        placeholder="Select Institution"
        :class="errors.institutionId ? 'p-invalid w-100' : 'w-100'"
/>

<small
        class="p-error"
        v-if="errors.institutionId"
>
    {{ errors.institutionId }}
</small>

                    </div>


                    <div class="col-md-6 mb-4">

                        <FormLabel
                                label-text="Phone Number ID"
                                :required="true"
                        />

                        <InputText
                                v-model="configData.phoneNumberId"
                                placeholder="Phone Number ID"
                                :class="errors.phoneNumberId ? 'p-invalid w-100' : 'w-100'"
                        />
                        <small
        class="p-error"
        v-if="errors.phoneNumberId"
>
    {{ errors.phoneNumberId }}
</small>

                    </div>


                    <div class="col-md-6 mb-4">

                        <FormLabel
                                label-text="WABA ID"
                                :required="true"
                        />

                        <InputText
                                v-model="configData.wabaId"
                                placeholder="WABA ID"
                                :class="errors.wabaId ? 'p-invalid w-100' : 'w-100'"
                        />
                        <small
        class="p-error"
        v-if="errors.wabaId"
>
    {{ errors.wabaId }}
</small>

                    </div>


                    <div class="col-md-6 mb-4">

                        <FormLabel
                                label-text="Token"
                                :required="true"
                        />

                        <Textarea
                                v-model="configData.token"
                                rows="5"
                                :class="errors.token ? 'p-invalid w-100' : 'w-100'"
                                placeholder="Access Token"
                                :autoResize="true"
                        />

                        <small
        class="p-error"
        v-if="errors.token"
>
    {{ errors.token }}
</small>

                    </div>


                    <div class="col-md-6 mb-4">

                        <div class="form-check mt-4">

                            <input
                                    class="form-check-input"
                                    type="checkbox"
                                    v-model="configData.active"
                            >

                            <label class="form-check-label">
                                Active
                            </label>

                        </div>

                    </div>

                </div>


                <div class="col-md-12 mt-3">

                    <Button
                            class="w-100"
                            :label="configData.id ? 'Update' : 'Save'"
                            :icon="configData.id ? 'pi pi-refresh' : 'pi pi-save'"
                            severity="primary"
                            @click="save"
                    />

                </div>

            </DashboardCard>

        </div>

    </DashboardContainer>

</template>

<script>

import DashboardContainer from "@/dashboard/containers/DashboardContainer.vue";
import DashboardCard from "@/dashboard/containers/DashboardCard.vue";
import Select from "primevue/select";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";

import FormLabel from "@/components/FormLabel.vue";

import {WHATSAPP_CONFIG_MODEL} from "@/dashboard/whatsapp/Whatsapp";

export default {

    name: "CreateWhatsappConfig",

    components : {
        DashboardContainer,
        DashboardCard,
        Button,
        InputText,
        Textarea,
        FormLabel,
        Select,
    },

    props : {
        config : {
            type : Object,
            required : true
        }
    },

    data(){
        return{

    institutions : [],

    errors : {},

    configData : {
        ...WHATSAPP_CONFIG_MODEL
    }
}
},

    methods : {

        save(){

 if(!this.validate()) return;
            
            let data = {
                ...this.configData
            };

            let url = "/whatsapp-config/save";

            if(data.id){
                url = "/whatsapp-config/update";
            }

            this.$api.post(url, data)
                .then(response => {

                    this.$root['showAlert'](
                        'success',
                        'WhatsApp Config',
                        response.message
                    );

                    this.configData = {
                        ...WHATSAPP_CONFIG_MODEL
                    };

                }).catch(error => {

                    this.$root['handleApiError'](
                        error,
                        'WhatsApp Config'
                    );

                });

        },

        validate(){

    this.errors = {};

    if(!this.configData.institutionId){

        this.errors.institutionId =
            "Institution is required";
    }

    if(!this.configData.phoneNumberId){

        this.errors.phoneNumberId =
            "Phone Number ID is required";
    }

    if(!this.configData.wabaId){

        this.errors.wabaId =
            "WABA ID is required";
    }

    if(!this.configData.token){

        this.errors.token =
            "Token is required";
    }

    return Object.keys(this.errors).length === 0;

},

        loadInstitutions(){

    let payload = {
        page : 1,
        size : 1000,
        blockSelector : "ALL",
        institutionType : "GENERAL",
        clientTimezone : "Asia/Calcutta"
    };

    this.$api.post(
        "/institution/get",
        payload
    ).then(response => {

        this.institutions =
            response.content.map(singleInstitution => {

                return {
                    ...singleInstitution,

                    displayName :
                        singleInstitution.id +
                        " - " +
                         singleInstitution.name.toUpperCase()
                };

            });

    }).catch(error => {

        this.$root['handleApiError'](
            error,
            "Institution Loading"
        );

    });

},

    },

   watch : {

    config : {

        immediate : true,

        handler(newValue){

            this.configData = {
                ...newValue
            };
        }
    }
},

beforeMount() {

    this.loadInstitutions();

}

}
</script>

<style scoped lang="scss">

</style>